import { gql } from '@apollo/client'

export const TOGGLE_USER_AVAILABILITY = gql`
  mutation updateUserAvailability($isAvailable: Boolean) {
    updateUserAvailability(isAvailable: $isAvailable) {
      id
      isAvailable
    }
  }
`

export const UPLOAD_FILE = gql`
  mutation SingleUpload($payload: SingleUploadPayload!) {
    singleUpload(payload: $payload) {
      id
      url
      status
    }
  }
`

export const DELETE_MEDIA_FILE = gql`
  mutation DeleteMediaEntry($deleteMediaEntryId: Int, $title: String) {
    deleteMediaEntry(id: $deleteMediaEntryId, title: $title) {
      id
      title
      mimetype
      url
    }
  }
`
